import { render, staticRenderFns } from "./articlemanagevenue.vue?vue&type=template&id=2dddfee4&scoped=true&"
import script from "./articlemanagevenue.vue?vue&type=script&lang=js&"
export * from "./articlemanagevenue.vue?vue&type=script&lang=js&"
import style0 from "./articlemanagevenue.vue?vue&type=style&index=0&id=2dddfee4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dddfee4",
  null
  
)

component.options.__file = "articlemanagevenue.vue"
export default component.exports